import { useEffect, useState } from 'react'

import { HTML_ELEMENT_THEME_PROVIDER_ID } from '../constants/html'
import { useInitActions, useInitData, useThemeMode } from '../hooks'
import { getApi, postApi } from '../utils/api'
import {
  createGradientFromColor,
  generateColorsFromGradient,
  getColorSet,
} from '../utils/gradient'
import { getThemeColor } from '../utils/theme'

function ThemeProvider({ children }) {
  const { setUkTheme } = useInitActions()

  const initData = useInitData()

  const { theme } = useThemeMode()

  const [position, setPosition] = useState(0)
  const [colorsTheme, setColorsTheme] = useState(null)

  useEffect(() => {
    if (colorsTheme) {
      if (!colorsTheme.id) {
        postApi({
          data: {
            colors: colorsTheme.colors,
          },
          endpoint: 'idwell-api/api/v3/customization/themes/',
        }).then(data => {
          setColorsTheme({ ...colorsTheme, id: data.data.id })
        })
      } else {
        postApi({
          endpoint: `idwell-api/api/v3/customization/themes/${colorsTheme.id}/set-as-main/`,
        }).then(() => {
          setUkTheme(colorsTheme)
        })
      }
    }
  }, [colorsTheme])

  function createGradient(color) {
    const width = 288
    const height = 288

    return createGradientFromColor({ color, height, width })
  }

  function createButtonGradient(color) {
    const { gradient } = createGradient(color)

    return gradient
  }

  function createHeaderGradient(color) {
    const { gradient, requiredPointIndex } = createGradient(color)

    setPosition(requiredPointIndex)

    return gradient
  }

  if (!initData.uk.config.theme && !colorsTheme) {
    getApi({ endpoint: '/api/uk/theme/' }).then(data => {
      const btnGradient = createButtonGradient(getColorSet(data.data.buttons))
      const headerGradient = createHeaderGradient(getColorSet(data.data.header))

      setColorsTheme({
        colors: {
          ...generateColorsFromGradient(position, headerGradient, btnGradient),
        },
      })
    })

    return null
  }

  if (!initData.uk.config.theme) {
    return null
  }

  // TODO Create selector
  const colors = initData.uk.config.theme.colors

  const style = getThemeColor(colors, theme)

  return (
    <div id={HTML_ELEMENT_THEME_PROVIDER_ID} style={style}>
      {children}
    </div>
  )
}

export default ThemeProvider
